
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar1 from "./Navbar";
import Table from "react-bootstrap/Table";
import { Col, Container, Row, Button, Spinner } from "react-bootstrap";
import Header from "./Header";
import axios from "axios";
import { useUser } from "./context/UserContext";
import { getBaseUrl } from "../api";

function Invoice() {
  const { loggedInUser } = useUser();
  const [billsData, setBillsData] = useState([]);
  const [invoiceFiles, setInvoiceFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [crn, setCrn] = useState(null);
  const navigate = useNavigate();
  const baseUrl = getBaseUrl();
  useEffect(() => {
    axios
      .post(`https://${baseUrl}/request`, { object: "crn", qdn: "diabrain" })
      .then((response) => {
        if (response.data && response.data.crn) {
          setCrn(response.data.crn);
        }
      })
      .catch((error) => console.error("Error fetching CRN:", error));
  }, []);

  useEffect(() => {
    if (!crn) return;

    setLoading(true);
    const requestData = {
      crn: crn,
      action: "R",
      object: "bill",
      user_id: loggedInUser,
    };

    axios
      .post(`https://${baseUrl}/request`, requestData)
      .then((response) => {
        let billArray =
          Array.isArray(response.data)
            ? response.data
            : response.data?.response || [];

        const formattedData = billArray.map((bill) => ({
          bill_num: bill.bill_num || "N/A",
          date: bill.ldt ? new Date(bill.ldt).toLocaleDateString() : "N/A",
          amount: bill.total ? parseFloat(bill.total) : 0,
          username: loggedInUser,
        }));

        setBillsData(formattedData);
      })
      .catch((error) => {
        console.error("Error fetching bill data:", error);
      })
      .finally(() => setLoading(false));
  }, [crn]);

  useEffect(() => {
    if (!crn) return;

    axios
      .post(`https://${baseUrl}/request`, {
        crn: crn,
        user: loggedInUser,
        object: "repos",
        action: "R",
      })
      .then((response) => {
        const files = response.data?.response || [];
        const invoiceFiles = files.filter(
          (item) => item.rep_type?.toLowerCase() === "invoice"
        );
        setInvoiceFiles(invoiceFiles);
      })
      .catch((error) => {
        console.error("Error fetching invoice files:", error);
      });
  }, [crn]);

  const handleView = (index) => {
    const invoice = invoiceFiles[index]; 
    if (invoice && invoice.external_name) {
      window.open(invoice.external_name, "_blank");
    } else {
      alert(`Invoice PDF not found for this bill.`);
    }
  };

  return (
    <>
      <Header />
      <Navbar1 />
      <Container className="mt-4">
        <Row className="align-items-center mb-3">
          <Col md="2" xs="4">
            <Button variant="danger" onClick={() => navigate("/home")}>
              ← Back
            </Button>
          </Col>
          <Col md="4" xs="6" className="text-center">
            <h2 className="mb-0">Billing Section</h2>
          </Col>
        </Row>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Table responsive>
            <thead className="table-header">
              <tr>
                <th className="text-center">Invoice No</th>
                <th className="text-center">Date</th>
                <th className="text-center">Amount</th>
                <th className="text-center">Actions</th>
              </tr>
            </thead>
            <tbody style={{ fontWeight: "bold" }}>
              {billsData.map((bill, index) => (
                <tr key={index}>
                  <td className="text-center">{bill.bill_num}</td>
                  <td className="text-center">{bill.date}</td>
                  <td className="text-center">₹{bill.amount.toFixed(2)}</td>
                  <td className="text-center">
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleView(index)}
                    >
                      View
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </Container>
    </>
  );
}

export default Invoice;
